import React from 'react';
import I18n from 'i18n-js';
import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import { HELP_CENTER_ARTICLE_ID } from '../../identity_verification/inform_act_verifications';
import { ConfettiIcon, WarningCircleIcon } from '@phosphor-icons/react';

export interface Props {
  phase: string;
  timeRemainingBeforeLock: string;
}

const InformActBanner = ({
  phase,
  timeRemainingBeforeLock,
}) => {
  // This should match the phase as defined in Reverb::InformActBanner in core
  const PHASE_ZERO = 'phase0';

  return (
    <RCCallout
      themeType="utility"
      variant={phase === PHASE_ZERO ? 'info-ultralight' : 'urgent-ultralight'}
      icon={phase === PHASE_ZERO ? <ConfettiIcon /> : <WarningCircleIcon />}
      title={I18n.t(`discovery.sellerDashboard.informActBanner.${phase}.title`, { timeRemainingBeforeLock })}
      cta={(
        <RCButtonLink
          variant="filled"
          renderLink={c => <CoreLink to={Paths.coreIdentityVerification.expand({})}>{c}</CoreLink>}
        >
          <Translate text="discovery.sellerDashboard.informActBanner.buttonText" />
        </RCButtonLink>
      )}
    >
      <Translate tag="p" text={`discovery.sellerDashboard.informActBanner.${phase}.description`}>
        <CoreLink
          className="text-link"
          target="_blank"
          to={Paths.helpCenterArticlesUrl.expand({ articleId: HELP_CENTER_ARTICLE_ID })}
        >
          <Translate text="discovery.sellerDashboard.informActBanner.helpCenterLinkText" />
        </CoreLink>
      </Translate>
    </RCCallout>
  );
};

export default InformActBanner;
